export const GIFT_CARD_FAQ_DATA = [
    {
        question: 'کارت‌های هدیه خانومی به چه صورت ارائه می‌شوند؟',
        answer: 'کارت‌های هدیه خانومی در دو قالب <span class="text-text-black"> فیزیکی(چاپی) </span> و <span class="text-text-black"> دیجیتال </span> ارائه می‌شوند.',
    },
    {
        question: 'حداقل تعداد سفارش برای کارت‌های هدیه چاپی چقدر است؟',
        answer: 'حداقل تعداد سفارش برای گیفت‌کارت‌های چاپی، <span class="text-text-black"> ۱۰ عدد </span> است.',
    },
    {
        question: 'زمان آماده‌سازی کارت‌های هدیه چاپی با طراحی اختصاصی چقدر است؟',
        answer: 'زمان آماده‌سازی کارت‌های چاپی با طراحی اختصاصی، معمولاً <span class="text-text-black"> ۳ تا ۴ روز کاری </span> خواهد بود.',
    },
    {
        question: 'زمان آماده‌سازی و تحویل کارت هدیه دیجیتال چقدر است؟',
        answer: 'تحویل کارت هدیه دیجیتال پس از انجام واریز، معمولاً <span class="text-text-black"> ۱ تا ۲ روز کاری </span> زمان می‌برد.',
    },
    {
        question: 'آیا امکان شخصی‌سازی طراحی کارت هدیه وجود دارد؟',
        answer: 'بله شما می‌توانید با استفاده از لوگو یا متن و طرح اختصاصی مورد نظرتان کارت‌ها را سفارش دهید.',
    },
    {
        question: 'فرآیند ثبت سفارش به چه صورت است؟',
        answer: 'ثبت سفارش از طریق ارسال ایمیل و پس از اعلام تعداد و مبلغ مورد نیاز، انجام می‌شود. <br /> آدرس ایمیل: <br /> <a href="mailto:b2b.giftcard@khanoumi.com" class="text-text-black">b2b.giftcard@khanoumi.com</a>',
    },
]
